import { Injectable } from '@angular/core';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GetCompanyAndUsersData {
  loggedInUserCompanyID!: number | null;
  loggedInCompanyFiscalyear!: string | null | undefined;
  currentFinancialYear!: string | null;
  loggedInUserId!: string | null;
  loggedInUserRole: any;
  loggedInUserEmail: any;
  loggedInUserEmpCode: any | null;
  loggedInUserName: any;
  getAllFinancialYears: any[] = [];

  loggedInUserType = {
    isSuperAdmin: false,
    isHrAdmin: false,
    isEmployee: false,
    isHOD: false
  };
  // buttonColorName!: string | null;

  allEmpList = [];
  isRNDEmployee = false;
  isL4AndAboveEmployee = false;

  constructor(
    private encryptionService: EncryptionService,
    private config: Config,
    private httpService: HttpService
  ) {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserEmail = sessionStorage.getItem('userEmail');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
      this.currentFinancialYear = this.getCurrentFinancialYear() || '';
    }

    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
      this.loggedInUserType = {
        isSuperAdmin: this.loggedInUserRole == 'Super Admin' || false,
        isHrAdmin: this.loggedInUserRole == 'HR Admin' || false,
        isEmployee: this.loggedInUserRole == 'Employee' || false,
        isHOD: this.loggedInUserRole == 'HOD' || false
      };
    }

    this.getAllEmployeeByCompanyID().subscribe((res: any) => {
      this.allEmpList = res?.data || [];

      const loggedInEmpId = this.loggedInUserId;
      const loggedInEmployee: any = this.allEmpList.find((emp: any) => emp.id === loggedInEmpId);
      if (loggedInEmployee) {
        /* ---------------- R&D Role ---------------- */
        this.isRNDEmployee = loggedInEmployee?.department === 'R&D';
        /* ---------------- L4 & Above Role ---------------- */
        this.isL4AndAboveEmployee = this.checkL4AndAbove(loggedInEmployee?.grade);
      }
    });

    this.getListOfFinancialYears();
  }

  getGlobalColors() {
    const dashboardColorName: string[] = sessionStorage.getItem('dashboardColorName')?.split(',') ?? ['#F6921E', '#F6921E'];
    const globalColors = {
      'phi-subModuleButtonColor': sessionStorage.getItem('subModuleButtonColor') ?? '#F6921E',
      'phi-buttonColorName': sessionStorage.getItem('buttonColorName') ?? '#F6921E',
      'phi-moduleNameColor': sessionStorage.getItem('moduleNameColor') ?? '#F6921E',
      'phi-dashboardColorName1': dashboardColorName[0],
      'phi-dashboardColorName2': dashboardColorName[1]
    };
    Object.entries(globalColors).forEach(([key, value]) => {
      document.documentElement.style.setProperty(`--${key}`, value);
    });
  }

  getCurrentFinancialYear() {
    if (!this.loggedInCompanyFiscalyear) return;
    const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
    return `${fiscalStartYear}-${fiscalEndYear}`;
  }

  getListOfFinancialYears() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe({
      next: (years: any) => {
        if (years?.status) {
          years?.data?.yearRanges.map((year: any) => {
            if (year) {
              const yearObj = {
                key: year || '',
                value: this.transformYearToFyFormat(year) || ''
              };
              this.getAllFinancialYears.push(yearObj);
            }
          });
        }
      },
      error: error => {
        console.log(error);
      }
    });
  }

  transformYearToFyFormat(value: string) {
    if (value == undefined) return;

    const [startYear, endYear] = value?.split('_');
    if (startYear == endYear) return `${startYear}`;
    return `FY ${startYear}-${endYear}`;
  }

  // ip: conversionValue='Apr_Mar' | op: 2025-2026
  convertFinancialYear(conversionValue: string, conversionFrom: 'yearNumberToText' | 'yearTextToNumber', splitSymbol: '-' | '_', finalcialYear: boolean = false) {
    let convertedValue = '';
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    if (conversionFrom === 'yearTextToNumber') {
      switch (conversionValue) {
        case 'Jan_Dec':
          convertedValue = `${currentYear}-${currentYear}`;
          break;
        case 'Apr_Mar':
          convertedValue = currentMonth < 3 ? `${currentYear - 1 + splitSymbol + currentYear}` : `${currentYear + splitSymbol + (currentYear + 1)}`;
          break;
        case 'July_Jun':
          convertedValue = currentMonth < 6 ? `${currentYear - 1 + splitSymbol + currentYear}` : `${currentYear + splitSymbol + (currentYear + 1)}`;
          break;
        case 'Oct_Sep':
          convertedValue = currentMonth < 9 ? `${currentYear - 1 + splitSymbol + currentYear}` : `${currentYear + splitSymbol + (currentYear + 1)}`;
          break;
      }
    } else if (conversionFrom === 'yearNumberToText') {
    }

    return finalcialYear ? `FY ${convertedValue}` : convertedValue;
  }

  getAllEmployeeByCompanyID() {
    return this.httpService.callGetService(`${this.config.getUserList}/${this.loggedInUserCompanyID}`);
  }

  getEmpDetail(raisedId: any, resolverId: any) {
    return forkJoin({
      raisedId: this.httpService.callGetService(`${this.config.getEployeeData}/${this.loggedInUserCompanyID}/${raisedId}`),
      resolverId: this.httpService.callGetService(`${this.config.getEployeeData}/${this.loggedInUserCompanyID}/${resolverId}`)
    });
  }

  // January, 2025 :- OP 2025-12-31
  getLastDateFromMonthName(monthName: string, year: number): string {
    const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth();
    const lastDay = new Date(year, monthIndex + 1, 0);

    // Format yyyy-MM-dd
    const y = lastDay.getFullYear();
    const m = String(lastDay.getMonth() + 1).padStart(2, '0');
    const d = String(lastDay.getDate()).padStart(2, '0');

    return `${y}-${m}-${d}`;
  }

  // ip: 2025_2026 December | op: 2025 / ip: 2025_2026 January | op: 2026
  getYearAsPerSelectedFinancialYearAnddMonth(financialYear: string | number, selectedMonth: string): number {
    const month = selectedMonth.toLowerCase();
    const janToMar = ['january', 'february', 'march'];

    // Handle single year (2026) or same year (2026_2026)
    if (!String(financialYear).includes('_') && !String(financialYear).includes('-')) {
      return Number(financialYear);
    }

    const [startYear, endYear] = String(financialYear).split(/[_-]/).map(Number);

    if (startYear === endYear) {
      return startYear;
    }

    // Jan–Mar → next FY year
    if (janToMar.includes(month)) {
      return endYear;
    }

    // Apr–Dec → start FY year
    return startYear;
  }

  // ip: 2025_2026 December | Op: {startDate: '2025-12-01', endDate: '2025-12-31'}
  getDateRangeAsPerSelectedFinancialYearAndMonth(financialYear: string | number, selectedMonth: string): { startDate: string; endDate: string } {
    const monthIndexMap: Record<string, number> = {
      january: 0,
      february: 1,
      march: 2,
      april: 3,
      may: 4,
      june: 5,
      july: 6,
      august: 7,
      september: 8,
      october: 9,
      november: 10,
      december: 11
    };

    const monthIndex = monthIndexMap[selectedMonth.toLowerCase()];
    if (monthIndex === undefined) {
      throw new Error('Invalid month');
    }

    // 🔹 Reuse your FY logic
    const year = this.getYearAsPerSelectedFinancialYearAnddMonth(financialYear, selectedMonth);

    // Start date → first day of month
    const start = new Date(year, monthIndex, 1);

    // End date → last day of month
    const end = new Date(year, monthIndex + 1, 0);

    const format = (date: Date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    };

    return {
      startDate: format(start),
      endDate: format(end)
    };
  }

  /**
   * Calculates the full range of a Financial Year based on a cycle string.
   * @param financialYear e.g., '2025_2026'
   * @param cycle e.g., 'Apr_Mar', 'Jan_Dec', 'July_Jun', 'Oct_Sep'
   */
  getFullFinancialYearRange(financialYear: string, cycle: string): { startDate: string; endDate: string } {
    const monthIndexMap: Record<string, number> = {
      jan: 0,
      feb: 1,
      mar: 2,
      apr: 3,
      may: 4,
      jun: 5,
      jul: 6,
      aug: 7,
      sep: 8,
      oct: 9,
      nov: 10,
      dec: 11
    };

    // 1. Parse the financial years
    const [startYear, endYear] = financialYear.split('_').map(Number);

    // 2. Parse the cycle months (e.g., 'Apr_Mar' -> ['apr', 'mar'])
    const [startMonthStr, endMonthStr] = cycle.toLowerCase().split('_');

    const startMonthIdx = monthIndexMap[startMonthStr.substring(0, 3)];
    const endMonthIdx = monthIndexMap[endMonthStr.substring(0, 3)];

    if (startMonthIdx === undefined || endMonthIdx === undefined) {
      throw new Error('Invalid cycle format. Use formats like Apr_Mar');
    }

    // 3. Logic for Start and End dates
    // Start is always the 1st of the startMonth in the startYear
    const startDateObj = new Date(startYear, startMonthIdx, 1);

    // End is the last day of the endMonth in the endYear
    // Day 0 of the following month gives the last day of the target month
    const endDateObj = new Date(endYear, endMonthIdx + 1, 0);

    const format = (date: Date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    };

    return {
      startDate: format(startDateObj),
      endDate: format(endDateObj)
    };
  }

  getDateInMs(dateStr: string): number {
    if (!dateStr) return 0;
    const [year, month, day] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day).getTime();
  }

  // compare two dates and send result true if its equal
  compareTwoDates(dateFirst: any, dateSecond: any) {
    return new Date(dateFirst).getTime() == new Date(dateSecond).getTime() ? true : false;
  }

  yearFun(financialYear: string) {
    const [startYear, endYear] = String(financialYear).split('_');
    return startYear + '-' + endYear;
  }

  // Check rnd
  checkIfIsRNDOrL4AndAboveEmployee(userId: any) {
    // console.log('this.allEmpList this.allEmpList ', this.allEmpList);
    const loggedInEmployee: any = this.allEmpList.find((emp: any) => +emp.id === +userId);

    /* ---------------- R&D or L4 & Above Role ---------------- */
    return {
      isRnd: loggedInEmployee?.department === 'R&D',
      isL4AndAbove: this.checkL4AndAbove(loggedInEmployee?.grade)
    };
  }
  // ----------------------- Check L4 and Above Employees ---------------------
  checkL4AndAbove(grade: string | null): boolean {
    if (!grade) return false;
    const level = Number(grade.replace('L', ''));
    return level >= 4;
  }

  // change date from "2026-01-08T15:09:16.729Z" to "2026-01-08"
  formatDateOnly(dateStr: string): string {
    return new Date(dateStr).toISOString().split('T')[0];
  }
}
